exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.charts-btn {\n    font-weight: 700;\n    margin-right: 10px;\n}\n.charts-btn.is-active {\n    color: #fff;\n    cursor: default;\n    pointer-events: none;\n}\n.charts-block {\n    height: 400px;\n    min-height: 400px;\n}\n.charts-block-empty {\n    position: relative;\n    display: flex;\n    height: 100%;\n    width: 100%;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n    font-weight: 700;\n    color: #cacaca;\n    min-height: 300px;\n}", ""]);

// exports
